import React, { useState } from 'react';

const FollowUpTable = ({
    followupTests,
    testResults,
    getTestValue,
    getBreakdownValue,
    handleTestValueChange,
    handleBreakdownValueChange,
    // handleAutoSave,
}) => {
    const [search, setSearch] = useState('');

    const query = search.trim().toLowerCase();

    const filteredTests = query
        ? followupTests
            .map((test) => {
                const nameMatch = test.testName?.toLowerCase().includes(query);
                const hasBreakdowns = test.breakdowns && test.breakdowns.length > 0;

                if (nameMatch) return test; // show whole test with all breakdowns

                if (hasBreakdowns) {
                    const matchedBreakdowns = test.breakdowns.filter((b) =>
                        b.name?.toLowerCase().includes(query)
                    );
                    if (matchedBreakdowns.length > 0) {
                        return { ...test, breakdowns: matchedBreakdowns };
                    }
                }

                return null;
            })
            .filter(Boolean)
        : followupTests;

    return (
        <div className='follow-up-table-container'>
            <div className='mb-2 mt-0 pt-0'>
                <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search tests..."
                    className='test-input'
                    style={{ width: '100%', padding: '2px 8px', fontSize: '13px' }}
                />
            </div>
            <table className='follow-up-table'>
                <thead>
                    <tr>
                        <th className='test-name-col'>Test Name</th>
                        <th className='value-col'>Value</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredTests.length === 0 ? (
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'center', fontSize: '13px', color: '#999', padding: '12px' }}>
                                No tests found
                            </td>
                        </tr>
                    ) : filteredTests.map((test) => (
                        <React.Fragment key={test.followupTest}>
                            {/* Main Test Row */}
                            <tr className='test-row'>
                                <td className='test-name-cell'>
                                    <strong>{test.testName}</strong>
                                </td>
                                <td className='value-cell'>
                                    {test.breakdowns && test.breakdowns.length > 0 ? (
                                        <span style={{ fontSize: '12px', color: '#666' }}>-</span>
                                    ) : (
                                        <input
                                            type="text"
                                            value={getTestValue(test.followupTest)}
                                            onChange={(e) => handleTestValueChange(test.followupTest, e.target.value)}
                                            // onBlur={handleAutoSave}
                                            placeholder="Enter value"
                                            className='test-input'
                                        />
                                    )}
                                </td>
                            </tr>

                            {/* Breakdown Rows */}
                            {test.breakdowns && test.breakdowns.length > 0 && test.breakdowns.map((breakdown, breakdownIndex) => (
                                <tr key={`${test.followupTest}-${breakdownIndex}`} className='breakdown-row'>
                                    <td className='test-name-cell breakdown-name'>
                                        <span className='breakdown-indent'>{breakdown.name}</span>
                                    </td>
                                    <td className='value-cell'>
                                        <input
                                            type="text"
                                            value={getBreakdownValue(test.followupTest, breakdown.name)}
                                            onChange={(e) => handleBreakdownValueChange(test.followupTest, breakdown.name, e.target.value)}
                                            // onBlur={handleAutoSave}
                                            placeholder={`Enter ${breakdown.name}`}
                                            className='test-input'
                                        />
                                    </td>
                                </tr>
                            ))}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default FollowUpTable;
